import _ from 'lodash';
import { Stack } from '@mui/material';
import ProgressChip from 'ui-component/extended/Chip/ProgressChip';
import { statusTextMapper } from 'constants/datagrid';
import { DecoratedKitRequestLine } from 'hooks/useGetDecoratedKitRequestLines';
import {
  StatusCount,
  KitRequestAllocationStatus,
  kitRequestAllocationStatusColorMapper,
} from 'hooks/useGetDecoratedKitRequestLines/utils';
import { ChipColor } from 'ui-component/extended/Chip';

type KitRequestLineStatusChipsProps = {
  kitRequestLine: DecoratedKitRequestLine;
  statusMapper?: Record<string, string>;
  statusColorMapper?: Record<string, ChipColor>;
};

export const KitRequestLineStatusChip = ({
  kitRequestLine,
  statusMapper = statusTextMapper,
  statusColorMapper = kitRequestAllocationStatusColorMapper,
}: KitRequestLineStatusChipsProps) => {
  const statuses = kitRequestLine.stats?.statusCounts as StatusCount[];

  const sortedStatuses = _.sortBy(statuses, (status) =>
    Object.values(KitRequestAllocationStatus).indexOf(status.status)
  );

  const statusLabels = _.chain(sortedStatuses)
    .map('status')
    .map((s) => statusMapper[s as keyof typeof statusMapper])
    .uniq()
    .value();

  // TODO: INV-490 Add tooltip showing all statuses and quantities
  return (
    <Stack direction="row" spacing={1}>
      <ProgressChip
        sections={
          sortedStatuses?.length > 0
            ? sortedStatuses.map((s) => ({
                chipColor: statusColorMapper[s.status],
                amount: s.quant,
              }))
            : [{ chipColor: ChipColor.grey, amount: 1 }]
        }
        label={statusLabels?.length > 0 ? statusLabels.join('/') : 'Unknown'}
        style={{ textTransform: 'uppercase' }}
      />
    </Stack>
  );
};
